export function formatDate(date) {
    return new Date(date).toISOString().replace(/[-:]/g, '').replace('T', '-').split('.')[0]
}